import api from "api/config";

export const GetMaintenanceTasksAPI = async (params) =>
  api({
    method: "GET",
    url: "/api/v1/maintenance/tasks",
    params,
  });

export const GetMaintenanceCountersAPI = async (params) =>
  api({
    method: "GET",
    url: "/api/v1/maintenance/counters",
    params,
  });

export const GetMaintenanceTaskByIdAPI = async (taskId) =>
  api({
    method: "GET",
    url: `/api/v1/maintenance/tasks/${taskId}`,
  });

export const CreateMaintenanceTaskAPI = async (data) =>
  api({
    method: "POST",
    url: "/api/v1/maintenance/tasks",
    data,
  });

export const UpdateMaintenanceTaskAPI = async ({ taskId, ...data }) =>
  api({
    method: "PATCH",
    url: `/api/v1/maintenance/tasks/${taskId}`,
    data,
  });

export const DeleteMaintenanceTaskAPI = async (taskId) =>
  api({
    method: "DELETE",
    url: `/api/v1/maintenance/tasks/${taskId}`,
  });

export const UpdateMaintenanceTaskStatusAPI = async ({ taskId, status }) =>
  api({
    method: "PATCH",
    url: `/api/v1/maintenance/tasks/${taskId}/status`,
    data: { status },
  });

export const UpdateMaintenanceBudgetAPI = async (data) =>
  api({
    method: "PUT",
    url: "/api/v1/maintenance/budget",
    data,
  });
